export default __webpack_public_path__ + "static/texture-8d0ea8a65f95308e346f899cdcac26e5.png";